import React, { useCallback, useEffect, useState } from 'react';
import { showSessionTimeoutModal } from '@utils/common';
import { getValueFromSearchParam } from '@utils/history';
import { Button } from 'antd';
import './errorPageStyles.scss';
import Logo from '@components/logo';
import NameInitialsDropdown from '@components/nameInitialsDropdown';
import { getProjectSetting } from '@service/apis';
import { projectRole } from '@model';
import commonActions from '@flux/action/common';
import { useDispatch, useSelector } from 'react-redux';
import FullScreenLoading from '@components/FullScreenLoading/FullScreenLoading';

export const ErrorBackTo = {
  projectList: 'projectList',
  projectDetail: 'projectDetail',
};

const BackButtonProps = {
  [ErrorBackTo.projectList]: {
    text: 'Go back to project list',
    onClick: (history) => history.push('/projects/list'),
  },
  [ErrorBackTo.projectDetail]: {
    text: 'Go back to project home',
    onClick: (history, projectId) =>
      projectId && history.push(`/project-detail/${projectId}`),
  },
};

const isValidProjectId = (projectId) =>
  Boolean(projectId) && projectId !== 'null';

function ErrorPage({ history, match, ...props }) {
  const params = getValueFromSearchParam('backTo', 'projectId');
  let backTo = params.backTo;
  const projectId = params.projectId;
  const dispatch = useDispatch();
  const [projectAdminUsers, setProjectAdminUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const systemThemeLoading = useSelector(
    (state) => state.common.systemThemeLoading,
  );
  if (backTo === ErrorBackTo.projectDetail && !isValidProjectId(projectId)) {
    backTo = ErrorBackTo.projectList;
  }
  const userInfo = window.localStorage.getItem('userInfo');

  const getProjectAdmin = useCallback(async (projectId) => {
    if (!isValidProjectId(projectId)) {
      setLoading(false);
      return;
    }
    try {
      const res = await getProjectSetting(projectId);
      const { teamInfo = {} } = res;
      const adminUsers = [
        teamInfo.manager,
        teamInfo.lead,
        ...(teamInfo.members || []),
      ].filter((i) => i?.permission === projectRole.Contributor);
      setProjectAdminUsers(adminUsers);
      console.log(res);
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (backTo === ErrorBackTo.projectDetail && isValidProjectId(projectId)) {
      setLoading(true);
      getProjectAdmin(projectId);
    } else {
      dispatch(commonActions.getSystemColorTheme());
    }
  }, [backTo, projectId]);

  useEffect(() => {
    if (!userInfo) {
      showSessionTimeoutModal();
    }
  }, [userInfo]);

  return (
    <div className="error-page-wrapper app-container">
      <header className="app-header">
        <Logo />
        <a className="landing-page-breadcrumb" href="/">
          <span
            style={{
              fontWeight: 'bold',
              color: 'var(--fontColorHighContrast)',
            }}
          >
            M&A Gateway
          </span>
        </a>
        <div className="avatar-wrapper">
          <NameInitialsDropdown />
        </div>
      </header>
      {userInfo ? (
        loading ? (
          <div className="a-loading a-primary a-m-10 a-loading-24" />
        ) : (
          <div className="content">
            <h1 className="title">
              <span className="appkiticon icon-alert-fill error" />
              Error
            </h1>
            <p className="message">
              Sorry, you do not have permission to access this page.
            </p>
            {projectAdminUsers.length ? (
              <div className="contact-info">
                <div>Please contact your project administrator.</div>
                <ul>
                  {projectAdminUsers.map((i) => (
                    <li>
                      {i.fullName}
                      <span className="email"> ({i.email})</span>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
            <p className="message">
              For further questions, please contact the PwC M&A Gateway team at{' '}
              <a
                href="mailto:us_dt_solution_innovation@pwc.com"
                targer="_blank"
              >
                us_dt_solution_innovation@pwc.com
              </a>
            </p>

            {backTo ? (
              <Button
                className="go-back-btn"
                type="primary"
                size="large"
                onClick={() =>
                  BackButtonProps[backTo]?.onClick(history, projectId)
                }
              >
                {BackButtonProps[backTo]?.text}
              </Button>
            ) : null}
          </div>
        )
      ) : null}
      <FullScreenLoading isLoading={systemThemeLoading} />
    </div>
  );
}

export default ErrorPage;
